import { useEffect, useMemo, useState } from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { useLocalSearchParams, useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { supabase } from '../lib/supabase'
import { colors, fonts } from '../lib/theme'
import { useThemeColors } from '../lib/useThemeColors'

export default function Confirm() {
  const tc = useThemeColors()
  const styles = useMemo(() => makeStyles(tc), [tc])
  const { t } = useTranslation()
  const params = useLocalSearchParams()
  const router = useRouter()

  const [status, setStatus]     = useState(t('confirm.verifying'))
  const [errorMsg, setErrorMsg] = useState(null)
  const [done, setDone]         = useState(false)

  useEffect(() => {
    const perform = async () => {
      const token_hash = params.token_hash
      const type       = params.type

      if (token_hash && type) {
        try {
          const { error } = await supabase.auth.verifyOtp({ token_hash, type })
          if (error) {
            setStatus(t('confirm.error'))
            setErrorMsg(error.message)
          } else {
            setStatus(t('confirm.success'))
            setDone(true)
            setTimeout(() => router.replace('/login'), 2000)
          }
        } catch (err) {
          setStatus(t('confirm.critical_error'))
          setErrorMsg(err.message)
        }
      } else {
        setStatus(t('confirm.missing_params'))
        setErrorMsg(t('confirm.missing_params_detail'))
      }
    }

    perform()
  }, [])

  return (
    <View style={[styles.container, { backgroundColor: '#0D0D0D' }]}>
      <Text style={styles.emoji}>{done ? '✅' : errorMsg ? '❌' : '🔄'}</Text>
      <Text style={styles.status}>{status}</Text>
      {errorMsg && (
        <View style={styles.errorBox}>
          <Text style={styles.errorText}>{errorMsg}</Text>
        </View>
      )}
    </View>
  )
}

const makeStyles = (tc) => StyleSheet.create({
  container: { flex: 1, alignItems: 'center', justifyContent: 'center', padding: 20 },
  emoji:     { fontSize: 48, marginBottom: 16 },
  status:    { fontFamily: fonts.condensedBold, fontSize: 20, color: tc.brandText, textAlign: 'center', marginBottom: 16 },
  errorBox:  { backgroundColor: 'rgba(255,68,68,0.1)', borderWidth: 1, borderColor: '#ff4444', borderRadius: 8, padding: 14, maxWidth: 320 },
  errorText: { color: '#ff4444', fontSize: 13, lineHeight: 20, textAlign: 'center' },
})